const zodiacs = [
  {
    sign: 'Scorpio',
    name: 'Scorpio ♏',
    description: 'Scorpio is considered the ultimate mystical sign of the zodiac. Deeply intuitive and emotionally intense, Scorpios are naturally drawn to the occult, transformation, and the hidden realms of existence. They have a natural ability to uncover secrets and delve into the mysteries of life, death, and rebirth.',
    traits: 'Powerful intuition, connection to transformation and rebirth, emotional depth.',
    magicalStrength: 'Shadow work, energy manipulation, and uncovering truths.'
  },
  {
    sign: 'Pisces',
    name: 'Pisces ♓',
    description: 'Pisces is the dreamer and mystic of the zodiac. Deeply connected to their emotions and the collective unconscious, Pisceans are highly empathetic and often experience psychic visions or profound insights through dreams. They’re naturally attuned to spiritual and esoteric practices.',
    traits: 'Compassionate, imaginative, and deeply intuitive.',
    magicalStrength: 'Dream work, water magic, and spiritual healing.'
  },
  {
    sign: 'Capricorn',
    name: 'Capricorn ♑',
    description: 'Though often seen as practical and grounded, Capricorn is linked to ancient wisdom and earth magic. They embody the archetype of the “crone” or wise elder in witchcraft, acting as keepers of traditions and protectors of sacred knowledge. Capricorns have a unique ability to connect with the power of the earth.',
    traits: 'Disciplined, wise, and grounded in tradition.',
    magicalStrength: 'Ritual magic, manifestation, and nature-based practices.'
  },
  {
    sign: 'Virgo',
    name: 'Virgo ♍',
    description: 'Virgo’s attention to detail and strong connection to nature make them exceptional healers and practitioners of herbal magic. Their analytical mind allows them to approach witchcraft with precision and care, often excelling in creating rituals and remedies.',
    traits: 'Practical, nurturing, and deeply connected to the physical world.',
    magicalStrength: 'Herbalism, healing, and ritual crafting.'
  },
  {
    sign: 'Aquarius',
    name: 'Aquarius ♒',
    description: 'Aquarius is the visionary and innovator of the zodiac. They are often drawn to unconventional and futuristic forms of magic, blending technology and spirituality. Known for their rebellious nature, Aquarians can be seen as modern-day alchemists or prophets, bringing new perspectives to mystical practices.',
    traits: 'Forward-thinking, rebellious, and innovative.',
    magicalStrength: 'Tech magic, divination, and astral projection.'
  },
  {
    sign: 'Cancer',
    name: 'Cancer ♋ (Honorable Mention)',
    description: 'Cancer is deeply connected to lunar energy and emotional intuition. Their nurturing and protective nature aligns them with hearth magic and spells that focus on home and family. Cancers also have a strong affinity for working with moon phases and water.',
    traits: 'Nurturing, intuitive, and emotionally connected.',
    magicalStrength: 'Lunar magic, protection spells, and emotional healing.'
  },
  {
    sign: 'Aries',
    name: 'Aries ♈',
    description: 'Aries is the fiery pioneer of the zodiac, embodying raw energy and fearless determination. While they may not traditionally be associated with mysticism, their courage and passion make them natural manifesters. They excel at setting intentions and channeling their willpower into making things happen.',
    traits: 'Bold, energetic, and action-oriented.',
    magicalStrength: 'Fire magic, courage spells, and manifestation.'
  },
  {
    sign: 'Taurus',
    name: 'Taurus ♉',
    description: 'Taurus is deeply connected to the earth and sensual pleasures. They thrive in practices that involve nature, beauty, and abundance. As natural nurturers, they often excel in rituals that enhance comfort, security, and prosperity.',
    traits: 'Grounded, patient, and resourceful.',
    magicalStrength: 'Earth magic, prosperity rituals, and spellwork for stability.'
  },
  {
    sign: 'Gemini',
    name: 'Gemini ♊',
    description: 'Gemini is the communicator and intellectual of the zodiac, making them highly versatile in magical practices. Their duality allows them to tap into both light and shadow energies. They excel in practices that involve communication, knowledge, and transformation.',
    traits: 'Curious, adaptable, and clever.',
    magicalStrength: 'Word magic, spell writing, and divination (e.g., tarot or runes).'
  },
  {
    sign: 'Leo',
    name: 'Leo ♌',
    description: 'Leo is all about charisma, creativity, and self-expression. Their radiant energy makes them natural performers in rituals and ceremonies. Leos excel at magic that draws attention, boosts confidence, or manifests personal success.',
    traits: 'Confident, creative, and generous.',
    magicalStrength: 'Solar magic, glamour spells, and rituals for self-empowerment.'
  },
  {
    sign: 'Libra',
    name: 'Libra ♎',
    description: 'Libra is ruled by Venus, making them naturally drawn to love, harmony, and beauty. They have a talent for creating balance in relationships and environments. Libras excel in love spells, peace rituals, and aesthetic magic.',
    traits: 'Diplomatic, artistic, and charming.',
    magicalStrength: 'Love magic, spells for harmony, and rituals for justice.'
  },
  {
    sign: 'Sagittarius',
    name: 'Sagittarius ♐',
    description: 'Sagittarius is the philosopher and adventurer of the zodiac, drawn to exploration and spiritual growth. They thrive in practices that involve expanding their horizons, whether through travel, learning, or connecting with universal truths.',
    traits: 'Optimistic, adventurous, and spiritual.',
    magicalStrength: 'Travel magic, spiritual quests, and fire rituals for freedom and expansion.'
  }
]

export { zodiacs };